export default __webpack_public_path__ + "static/media/background_login.ebcb9160.svg";